module.exports = __webpack_public_path__ + "img/introduction.5a26e3c3.png";